import { motion } from "framer-motion";
import HighlightButton from "../components/HighlightButton";

const testimonials = [
  {
    name: "Shrikant Dasari",
    role: "Consulting Manager at KPMG | Driving Digital & Process Transformation for Global Banks | 16+ Years in BFSI | Business Analysis & Stakeholder Leadership",
    paragraphs: [
      "I have been working with Tuhin for the last two years, and one thing I can say for sure is that he’s extremely skilled and hardworking.",
      "He always gives his 110% to whatever task is assigned, and you can always count on him to deliver.",
      "Tuhin is a key asset to any team. His knowledge in data analysis and AI is way ahead of his years of experience, which really sets him apart.",
      "I truly believe he would be a great addition to any team, and I wish him all the best for his future.",
    ],
  },
  {
    name: "Raghavendra Shanbhag",
    role: "Silicon Engineering Senior Manager at Accenture in India",
    paragraphs: [
      "There can be no better colleague than Tuhin, He is one of the most dedicated person I’ve worked with during my PG courses and is willing to put that extra help whenever you need it. We’ve joined our hands on multiple projects, and Tuhin is one of the best people I had as a partner.",
      "I would love to recommend his expertise to any person looking for an Data science problem with AIML Solution . His ability to tackle complex problems is remarkable and with a warm smile. I am sure Tuhin stands out and would be an appreciated member of any team.",
    ],
  },
  {
    name: "Gaurav Joshi",
    role: "Gen AI Enablement | AI Gateway | ML Platforms | ML Engineer",
    paragraphs: [
      "Tuhin is a talented young data science enthusiast with a strong knowledge in machine learning and AI concepts. He is a quick learner as well. I am confident  that he will be an asset to any organization that he serves.",
    ],
  },
];

function Home() {
  return (
    <>
      <section
        id="home"
        name="home"
        className="bg-home portfolio-hero scroll-mt-[80px]"
      >
        <div className="hero-layout">
          <motion.div
            className="hero-copy"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55, ease: "easeOut" }}
          >
            <p className="hero-kicker"><span /> Data · AI · Engineering</p>
            <h1>Tuhin Kr. Dutta</h1>
            <h2>AI & Data Science Engineer</h2>
            <h3>System Design | AI/ML Full-Stack Development</h3>
            <p className="hero-intro">
              Designing solutions powered by data, machine learning, and AI –
              transforming complexity into real-world impact.
            </p>

            <div className="hero-actions">
              <HighlightButton />
              <a href="https://virtual.tuhindutta.com" target="_blank" rel="noopener noreferrer">
                🤖 Ask My AI Chatbot <span aria-hidden="true">↗</span>
              </a>
              <a href="/faq" target="_blank" rel="noopener noreferrer">
                ❓ FAQ <span aria-hidden="true">↗</span>
              </a>
            </div>
          </motion.div>

          <img
            className="hero-avatar"
            src="https://avatars.githubusercontent.com/u/64041986?v=4"
            alt="Tuhin Kr. Dutta"
          />
        </div>

        <div className="hero-bottomline">
          <span>Portfolio / Selected work & writing</span>
        </div>
      </section>

      <section id="testimonials" name="testimonials" className="recommendations-section">
        <div className="recommendations-container">
          <div className="recommendations-heading">
            <div>
              <h2>Recommendations</h2>
              <p className="recommendations-intro">
                A few words from people I’ve had the opportunity to work and learn with.
              </p>
            </div>
            <a
              href="https://www.linkedin.com/in/t-k-dutta"
              target="_blank"
              rel="noopener noreferrer"
              className="linkedin-recommendations-link"
            >
              View recommendations on LinkedIn <span aria-hidden="true">↗</span>
            </a>
          </div>

          <div className="recommendations-grid">
            {testimonials.map(({ name, role, paragraphs }, index) => (
              <motion.article
                key={name}
                className="recommendation-card"
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: index * 0.08 }}
                viewport={{ once: true, amount: 0.15 }}
              >
                <span className="recommendation-mark" aria-hidden="true">“</span>
                <div className="recommendation-quote">
                  {paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                </div>
                <footer className="recommendation-author">
                  <strong>{name}</strong>
                  <span>{role}</span>
                </footer>
              </motion.article>
            ))}
          </div>
          <p className="recommendations-note">
            Shared here for convenience. Visit LinkedIn for the original recommendations.
          </p>
        </div>
      </section>
    </>
  );
}

export default Home;
